import { RouteProps } from 'react-router-dom';
import { GLOBAL_PATHS_ROUTES } from './GlobalPaths';

export const ROUTES: RouteProps[] = [...GLOBAL_PATHS_ROUTES];
